import { Button, Group, Select, Text } from "@mantine/core";
import React, { useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import { openFileUrl } from "../utils/openReport";
import { DATA_REPORT_DATE_TYPE } from "../data/options";

const ReportFwdBusinessSubmission = () => {
  const [loading, setLoading] = useState(false);
  const [api] = useServerApi();
  const { t } = useTranslation();
  const [asOf, setAsOf] = useState(null);
  const [dateType, setDateType] = useState("submissionDate");

  const canDownload = Boolean(asOf && dateType);

  const downloadReport = async () => {
    try {
      setLoading(true);
      const result = await api.FwdReport.getBusinessSubmission({
        asOf,
        dateType,
      });
      if (result?.url) {
        await openFileUrl(result.url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Text size="xs">
        {t("Please select the as-of month and the order date to use.")}
      </Text>
      <Group mt="xs">
        <DatePicker
          title={t("As of")}
          size="xs"
          allowFreeInput
          placeholder={t("As of")}
          value={asOf}
          onChange={setAsOf}
        />
        <Text size="xs">by</Text>
        <Select
          size="xs"
          value={dateType}
          data={DATA_REPORT_DATE_TYPE.map((option) => ({
            ...option,
            label: t(option.label),
          }))}
          onChange={(type) => setDateType(type || "submissionDate")}
        />
      </Group>
      <Button
        size="xs"
        mt="xl"
        onClick={downloadReport}
        loading={loading}
        disabled={!canDownload}
      >
        {t("Download")}
      </Button>
    </div>
  );
};

export default ReportFwdBusinessSubmission;
